import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Drawer,
  Input,
  Row,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { BsArrowRight, BsSearch } from "react-icons/bs";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdCancel } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import ProductCard from "../../Components/ProductCard/ProductCard";
import ProductSkeleton from "../../Components/ProductSkeleton/ProductSkeleton";
import ProductSlider from "../../Components/Sliders/ProductSlider/ProductSlider";
import axios from "../../config/axios";
import {
  useCatalogQuery,
  useDiscountedProducts,
} from "../../Hooks/useProductsBySubCategory";
import styles from "./ProductsByBrand.module.scss";
import filter_icon from "./images/filter.svg";
// import scan_icon from "./images/scan_icon.svg";
import search_icon from "./images/search.svg";

const EMPTY_FILTER_OPTIONS = {
  discounts_and_offer_count: 0,
  sub_categories: [],
};

const ProductsByBrand = () => {
  const { slug } = useParams();

  // const [subCategory, setSubCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("latest");
  const [count, setCount] = useState(0);
  const [products, setProducts] = useState([]);
  // const [brands, setBrands] = useState([]);
  // same cache entry as the landing page's "Discounts & Offers" slider
  const { products: discountedProducts } = useDiscountedProducts();

  const [filterSubSubCat, setFilterSubSubCat] = useState([]);
  const [filterSubCategories, setFilterSubCategories] = useState([]);

  const [filterNutriScore, setFilterNutriScore] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [showMobileDrawer, setShowMobileDrawer] = useState(false);
  const [brand, setBrand] = useState({
    name: "",
    banner: null,
    mobile_banner: null,
  });

  // desktop filter ui states
  const { data: desktopFilterUIStates = EMPTY_FILTER_OPTIONS } = useCatalogQuery(
    "/public/products/filters/get-options",
    {
      params: { brand: slug.split("_")[1] },
      transform: (data) => ({
        discounts_and_offer_count: data.discounts_and_offer_count,
        sub_categories: data.sub_categories,
      }),
    },
  );

  // get recently viewed products from local storage
  const recentlyViewedProducts = window.localStorage.getItem("recentlyViewed")
    ? JSON.parse(window.localStorage.getItem("recentlyViewed"))
    : [];

  // desktop filter states
  const [desktopFilters, setDesktopFilters] = useState({
    discounts_and_offer: [],
    sub_categories: [],
  });

  useEffect(() => {
    document.title = brand.name + " - Desi Fresh";
  }, [brand.name]);

  useEffect(() => {
    // format the desktop filters for api call
    const subcategories = desktopFilters.sub_categories.map(
      (subcategories) => subcategories.split("/")[1],
    );
    setFilterSubCategories(subcategories);
  }, [desktopFilters]);

  //getting products
  useEffect(() => {
    (async () => {
      try {
        if (page === 1) {
          setLoading(true);
          window.scrollTo(0, 0);
        }
        const response = await axios.get("/public/products", {
          withCredentials: false,
          params: {
            page: page,
            limit: 24,
            sort_by: sortBy,
            brand_slug: slug.split("_")[0],
            search_term: searchTerm ? searchTerm : null,
            discount:
              desktopFilters.discounts_and_offer.length > 0 ? true : null,
            sub_categories:
              filterSubCategories.length > 0
                ? filterSubCategories.join()
                : null,
          },
        });
        setCount(response.data.count);
        setBrand({
          name: response.data.results[0].brand.name,
          banner: response.data.results[0].brand.banner,
          mobile_banner: response.data.results[0].brand.mobile_banner,
        });
        if (page === 1) {
          setProducts(response.data.results);
        } else {
          setProducts((prev) => [...prev, ...response.data.results]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    page,
    slug,
    filterSubSubCat,
    filterSubCategories,
    filterNutriScore,
    sortBy,
    searchTerm,
    desktopFilters,
  ]);

  // defining resetFilter function that will reset all the filters in the drawer
  const resetFilter = () => {
    setFilterSubSubCat([]);
    setFilterSubCategories([]);
    setFilterNutriScore([]);
    setDesktopFilters({
      discounts_and_offer: [],
      sub_categories: [],
    });
  };

  return (
    <Layout>
      <div>
        <div className="container">
          <Row>
            <Col lg={0} xs={24}>
              <BreadCrumb
                list={[
                  {
                    name: "Home",
                    link: "/",
                  },
                  {
                    name: `Brand - ${brand.name}`,
                    link: `/brand/${slug}_${brand.id}`,
                  },
                ]}
              />
            </Col>
            <Col lg={24} xs={0} style={{ marginTop: 10 }}>
              <BreadCrumb
                list={[
                  {
                    name: "Back To Home",
                    link: "/",
                  },
                  {
                    name: `Brand - ${brand.name}`,
                    link: `/brand/${slug}_${brand.id}`,
                  },
                ]}
              />
            </Col>
          </Row>

          <div className="row">
            <div className="d-none d-lg-block">
              <img
                src={
                  brand.banner ??
                  "https://desi-fresh.b-cdn.net/misc/discount_cat_banner.png"
                }
                alt="discount"
                loading="lazy"
                className="img-fluid mt-2 rounded-3"
              />
            </div>
            <div className="d-block d-lg-none">
              <img
                src={
                  brand.mobile_banner ??
                  "https://desi-fresh.b-cdn.net/misc/discount_cat_banner_mobile.png"
                }
                alt="discount"
                loading="lazy"
                className="img-fluid rounded-3"
              />
            </div>
          </div>

          <div className={styles.title_and_filter}>
            <Row gutter={[10, 10]}>
              <Col lg={24} xs={0}>
                <div className="mt-4"></div>
                <DesktopFilter
                  desktopFilters={desktopFilters}
                  setDesktopFilters={setDesktopFilters}
                  desktopFilterUIStates={desktopFilterUIStates}
                />
              </Col>
              <Col lg={6} xs={24}>
                <div className={styles.title}> {brand.name} </div>

                <div className={styles.mobile_title_filter}>
                  <Input
                    placeholder="Find it fast with our search!"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    prefix={<img src={search_icon} alt="search_icon" />}
                    suffix={
                      <>
                        {/* <img src={scan_icon} alt="scan_icon" /> */}
                        <img
                          src={filter_icon}
                          onClick={() => setShowMobileDrawer(true)}
                          alt="filter_icon"
                          className={styles.filter_icon}
                        />
                      </>
                    }
                  />
                </div>

                <Drawer
                  placement="right"
                  onClose={() => setShowMobileDrawer(false)}
                  open={showMobileDrawer}
                  width={"100vw"}
                  closable={false}
                  bodyStyle={{
                    marginBottom: "5rem",
                    padding: 0,
                  }}
                >
                  <div className={styles.filter_drawer_body}>
                    <div className={styles.filter_drawer_top}>
                      <h5
                        className={styles.filter_drawer_reset}
                        onClick={resetFilter}
                      >
                        Reset
                      </h5>
                      <h4 className={styles.filter_drawer_headline}>Filter</h4>
                      <IoCloseCircleOutline
                        onClick={() => setShowMobileDrawer(false)}
                        size={22}
                      />
                    </div>
                    <div className={styles.filter_drawer_collapse}>
                      {/* Mobile Filter Area */}
                      <Filter
                        header="Discounts"
                        onChange={(checkedValues) => {
                          setDesktopFilters((prev) => ({
                            ...prev,
                            discounts_and_offer: checkedValues,
                          }));
                        }}
                        value={desktopFilters.discounts_and_offer}
                        items={[
                          {
                            label: "Offers & discounts",
                            value: "offers_and_discounts",
                            amount:
                              desktopFilterUIStates?.discounts_and_offer_count,
                          },
                        ]}
                      />

                      <Filter
                        header="Categories"
                        onChange={(checkedValues) => {
                          setDesktopFilters((prev) => ({
                            ...prev,
                            sub_categories: checkedValues,
                          }));
                        }}
                        value={desktopFilters.sub_categories}
                        items={desktopFilterUIStates?.sub_categories.map(
                          (subcategory) => ({
                            label: subcategory.sub_category__name,
                            value: subcategory.sub_category__id,
                            amount: subcategory.dcount,
                          }),
                        )}
                      />

                      <div className={styles.filter_drawer_button}>
                        <Button
                          size="large"
                          onClick={() => setShowMobileDrawer(false)}
                          type="primary"
                          block
                        >
                          Show{" "}
                          <span
                            style={{
                              fontSize: 17,
                              marginInline: 4,
                              fontWeight: 600,
                            }}
                          >
                            {count}
                          </span>{" "}
                          Products
                        </Button>
                      </div>
                    </div>
                  </div>
                </Drawer>
              </Col>
            </Row>
          </div>

          <Row>
            <Col lg={0} xs={24}>
              <div className={styles.products_number}>
                <div className={styles.subcat_name}> {brand.name} </div>
                <div className={styles.prod_count}> {count} Articles </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={6} xs={0}>
              <div
                className={styles.products_number}
                style={{
                  marginTop: 5,
                }}
              >
                <div className={styles.prod_count}>
                  {count} Articles in {brand.name}
                </div>
              </div>
            </Col>
            <Col lg={15} offset={3} xs={0}>
              <Row gutter={[16, 16]}>
                <Col lg={11} offset={7}>
                  <Input.Search
                    placeholder="Search Product"
                    onSearch={(value) => setSearchTerm(value)}
                    enterButton={
                      <BsArrowRight
                        size={18}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    }
                    prefix={
                      <BsSearch
                        size={16}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: 8,
                        }}
                      />
                    }
                  />
                </Col>
                <Col lg={6}>
                  <div
                    className={`${styles.filter_products} justify-content-end`}
                  >
                    <label htmlFor="articles">Sort by</label>
                    <Select
                      value={sortBy}
                      onChange={(value) => setSortBy(value)}
                    >
                      <Select.Option value="latest">Latest Items</Select.Option>
                      <Select.Option value="popular">
                        Most Popular
                      </Select.Option>
                    </Select>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="pt-4">
            {loading ? (
              <ProductSkeleton />
            ) : (
              <>
                {products?.length > 0 ? (
                  <InfiniteScroll
                    dataLength={products?.length}
                    next={
                      products?.length < count
                        ? () => {
                            setPage((prev) => prev + 1);
                          }
                        : null
                    }
                    hasMore={count > products?.length}
                    loader={
                      <div className="mt-3">
                        <ProductSkeleton />
                      </div>
                    }
                    style={{
                      overflowX: "hidden",
                    }}
                    scrollThreshold={0.5}
                  >
                    <div className="row g-4">
                      {products?.map((product, index) => (
                        <div className="col-6 col-lg-2" key={index}>
                          <ProductCard product={product} />
                        </div>
                      ))}
                    </div>
                  </InfiniteScroll>
                ) : (
                  <div className="col-12 text-center">No Products Found</div>
                )}
              </>
            )}
            <div className="mt-3" />
          </div>

          <Divider style={{ margin: 0 }} />

          {/* recommended product slider */}
          <Row style={{ margin: "1rem 0" }}>
            <Col lg={24} xs={24}>
              <ProductSlider
                showDiscountVariants
                products={discountedProducts}
                title="Discount & Offers"
                link="/"
              />
            </Col>
          </Row>

          <div className="dt_only container">
            <Divider />
          </div>

          {/* recently viewed slider */}
          {recentlyViewedProducts.length > 0 && (
            <Row style={{ margin: "1rem 0" }}>
              <Col lg={24} xs={24}>
                <ProductSlider
                  products={recentlyViewedProducts}
                  title="Recently Viewed"
                  link="/"
                />
              </Col>
            </Row>
          )}
        </div>

        <div className="dt_only container">
          <Divider style={{ margin: 0 }} />
        </div>
      </div>
    </Layout>
  );
};

export default ProductsByBrand;

const Filter = ({ header, items, value, onChange }) => {
  return (
    <Collapse expandIconPosition="end" defaultActiveKey={["1"]} ghost>
      <Collapse.Panel header={header} key="1">
        <Checkbox.Group
          value={value}
          key={1}
          onChange={onChange}
          style={{ width: "100%" }}
        >
          {items.map((item, index) => {
            return (
              <div className={styles.checkbox_wrapper} key={index}>
                <Checkbox
                  style={{ textTransform: "capitalize" }}
                  value={`${item.label}/${item.value}`}
                >
                  {item.label}
                </Checkbox>
                <span>({item.amount} )</span>
              </div>
            );
          })}
        </Checkbox.Group>
      </Collapse.Panel>
    </Collapse>
  );
};

const DesktopFilter = ({
  desktopFilters,
  setDesktopFilters,
  desktopFilterUIStates,
}) => {
  const [filtersSelected, setFiltersSelected] = useState([]);
  const { slug } = useParams();

  useEffect(() => {
    let label = [];
    // store array of objects in label array
    for (let key in desktopFilters) {
      if (desktopFilters.hasOwnProperty(key)) {
        const element = desktopFilters[key];
        label = [...label, ...element];
      }
    }
    setFiltersSelected(label);

    // format desktop filters and extract the slugs by splitting the string by /

    setDesktopFilters(desktopFilters);
  }, [desktopFilters, setDesktopFilters]);

  const handleCrossBtnClick = (item) => {
    // remove the item from the selected filters
    const newFiltersSelected = filtersSelected.filter(
      (filter) => filter !== item,
    );
    setFiltersSelected(newFiltersSelected);

    // remove the item from the desktop filters also
    for (const key in desktopFilters) {
      if (desktopFilters.hasOwnProperty(key)) {
        const element = desktopFilters[key];
        if (element.includes(item)) {
          const newDesktopFilters = {
            ...desktopFilters,
            [key]: element.filter((filter) => filter !== item),
          };
          setDesktopFilters(newDesktopFilters);
        }
      }
    }
  };

  // on slug change reset the desktop filters
  useEffect(() => {
    setFiltersSelected([]);
    setDesktopFilters({
      discounts_and_offer: [],
      sub_categories: [],
    });
  }, [slug]);

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Discount
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    discounts_and_offer: checkedValues,
                  }));
                }}
                value={desktopFilters.discounts_and_offer}
              >
                <Row>
                  {[
                    {
                      label: "Offers & discounts",
                      value: "offers_and_discounts",
                      amount: desktopFilterUIStates?.discounts_and_offer_count,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={`${item.label}/${item.value}`}>
                          {item.label}
                        </Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Categories
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    sub_categories: checkedValues,
                  }));
                }}
                value={desktopFilters.sub_categories}
                items={desktopFilterUIStates?.sub_categories.map(
                  (subcategory) => ({
                    label: subcategory.sub_category__name,
                    value: subcategory.sub_category__id,
                    amount: subcategory.dcount,
                  }),
                )}
              >
                <Row>
                  {desktopFilterUIStates?.sub_categories.map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox
                          value={`${item.sub_category__name}/${item.sub_category__id}`}
                        >
                          {item.sub_category__name}
                        </Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.dcount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {filtersSelected.length > 0 && (
            <div className={styles.desktop_filter_selected_items_wrapper}>
              {filtersSelected.map((item, index) => (
                <div
                  className={styles.desktop_filter_selected_items}
                  key={index}
                >
                  {item.split("/")[0]}
                  <MdCancel
                    size={18}
                    onClick={() => {
                      handleCrossBtnClick(item);
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};
